import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { UserNotification } from 'modules/domain/userNotifications/types'
import { EntityMetadata } from 'modules/domain/types'

const userNotificationsDict = (state: AppGlobalState) => state.userNotifications.items
const ids = (state: AppGlobalState) => state.userNotifications.ids
const userNotification = (state: AppGlobalState, id: string): UserNotification | undefined =>
  state.userNotifications.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<UserNotification> =>
  state.userNotifications.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.userNotifications.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.userNotifications.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.userNotifications.listFetchError
const userNotificationList = createSelector(userNotificationsDict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: UserNotification[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.userNotifications.filter
const sorting = (state: AppGlobalState) => state.userNotifications.sorting
const page = (state: AppGlobalState) => state.userNotifications.page
const total = (state: AppGlobalState) => state.userNotifications.total
const pageSize = (state: AppGlobalState) => state.userNotifications.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.userNotifications.total / state.userNotifications.pageSize)

const UserNotificationSelectors = {
  filter,
  sorting,
  page,
  total,
  userNotificationsDict,
  ids,
  userNotification,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  userNotificationList,
  pageSize,
  pages,
}

export default UserNotificationSelectors
